import { Box, Grid, Text } from '@customerio/pluma-components/react';

export function MetadataRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <Grid columns="80px 1fr" gap="100" alignItems="center">
      <Text size="xxs" color="subtle">
        {label}
      </Text>
      <Box minW="0">{children}</Box>
    </Grid>
  );
}
